import { defineStore } from "pinia";
import { actions } from "./actions";

export const useFelixBagAuxStore = defineStore("FelixBagAux", {
  state: () => ({
    scenes:{
      escolha_de_perfil: 101,
      preenchimento_de_cadastro: 123,
      apresentacao_menu: 148.7,
      menu: 163.9,
      avaliacao_final_acolhimento: 243.7,
      final_acolhimento: 286,
      avaliacao_final_cuidados: 297.7,
      final_cuidados: 335.7
    },
    form:{
      profile: {}
    },
    token: '',
    TOKEN_VIDEOBOT: '',
  }),
  getters: {},
  actions,
});
